"use strict";

import { createBrowserHistory } from "history";
import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import { createLogger } from "redux-logger";
import { createEpicMiddleware } from "redux-observable";
import { composeWithDevTools } from "redux-devtools-extension";
// import { connectRouter, routerMiddleware } from "connected-react-router";
import { BehaviorSubject } from "rxjs";
import { switchMap } from "rxjs/operators";

import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage/session";
import epics from "../_epics";
import reducers from "../_reducers";
import { authConstants } from "../_constants";
import { messageMiddleware, loadingSpinnerMiddleware } from "../_middlewares";

const persistConfig = {
    key: "root",
    storage,
    stateReconciler: (inboundState, originalState, reducedState) => {
        return reducedState;
    },
    blacklist: ["errorMessage", "auth", "successMessage", "loading"],
};

const history = createBrowserHistory();

const configureStore = () => {
    const rootReducer = combineReducers({
        ...reducers,
        // router: connectRouter(history),
    });

    const reducer = (state, action) => {
        if (action.type === authConstants.AUTH_CLEAR_STORE) {
            storage.removeItem("persist:root");
            state = { router: { ...state.router } };
        }
        return rootReducer(state, action);
    };

    const epicMiddleware = (store) => {
        const originalEpicMiddleware = createEpicMiddleware({
            dependencies: {
                dispatch: store.dispatch,
            },
        });

        const storeMiddleware = originalEpicMiddleware(store);

        epicMiddleware.run = originalEpicMiddleware.run;

        return storeMiddleware;
    };
    // const router = routerMiddleware(history);
    const loggerMiddleware = createLogger();

    const middlewares = [
        epicMiddleware,
        // router,
        messageMiddleware,
        loadingSpinnerMiddleware,
        // loggerMiddleware,
    ];

    const epic$ = new BehaviorSubject(epics);

    const hotReloadingEpic = (...args) =>
        epic$.pipe(switchMap((epic) => epic(...args)));

    let configuredStore = {};

    if (process.env.NODE_ENV === "production") {
        configuredStore = createStore(
            persistReducer(persistConfig, reducer),
            compose(applyMiddleware(...middlewares)),
        );
    } else {
        // loggerMiddleware;
        configuredStore = createStore(
            persistReducer(persistConfig, reducer),
            composeWithDevTools(
                applyMiddleware(...middlewares), //loggerMiddleware
            ),
        );
    }

    epicMiddleware.run(hotReloadingEpic);

    // if (module.hot) {
    //     module.hot.accept("../_epics", () => {
    //         const nextRootEpic = require("../_epics").default;
    //         epic$.next(nextRootEpic);
    //     });
    // }
    return configuredStore;
};

export { history, configureStore };
